import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-legend-graph',
    templateUrl: './legend-graph.component.html',
    styleUrls: ['./legend-graph.component.scss'],
    standalone: false
})
export class LegendGraphComponent implements OnInit {
  @Input() legendChoose;
  constructor() { }

  ngOnInit() {
  }

}
